import type { WidgetDefinition } from '../WidgetDefinition';
import { faTable } from '@fortawesome/pro-regular-svg-icons/faTable';
import type { TableWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import type { TableWidgetViewModel } from 'src/store/types';

class TableWidgetDefinition implements WidgetDefinition<TableWidgetViewModel, TableWidgetModel> {
    type = 'table' as const;
    nameKey = 'widgets::table::name' as const;
    roles = ['widgets::table'];
    icon = faTable;
    category = 'widgets::categories::misc' as const;

    /**
     * Converts a Table widget from contract model to view model
     */
    toViewModel(widget: TableWidgetModel): TableWidgetViewModel {
        return widget;
    }

    /**
     * Converts a Table widget from view model to contract model
     */
    toContractModel(widget: TableWidgetViewModel): TableWidgetModel {
        return widget;
    }
}

export const tableWidgetDefinition = new TableWidgetDefinition();
